const { debounce } = window.BAO.Utils

class CompleteProductsCarousel extends window.BAO.Carousel.Element {
  connectedCallback () {
    super.connectedCallback()
  }

  setupListeners () {
    super.setupListeners()

    this.externalEls.trigger.elements.forEach(element => {
      element.addEventListener('click', () => {
        if (window.innerWidth <= window.BAO.MediaBreakpoints.breakpoints.md) {
          this.carousel = this.initialiseCarousel()
        }
        if (
          this.carousel &&
          window.innerWidth > window.BAO.MediaBreakpoints.breakpoints.md
        ) {
          this.carousel.destroy()
          this.carousel = null
        }
      })
    })

    window.addEventListener(
      'resize',
      debounce(() => {
        if (
          !this.carousel &&
          window.innerWidth <= window.BAO.MediaBreakpoints.breakpoints.md
        ) {
          this.carousel = this.initialiseCarousel()
        }
        if (
          this.carousel &&
          window.innerWidth > window.BAO.MediaBreakpoints.breakpoints.md
        ) {
          this.carousel.destroy()
          this.carousel = null
        }
      }, 100),
    )
  }

  initialiseCarousel () {
    if (window.innerWidth <= window.BAO.MediaBreakpoints.breakpoints.md) {
      return new window.KeenSlider(
        this.els.slides.element,
        {
          selector: this.els.slide.selector,
          defaultAnimation: {
            duration: 1500,
          },
          loop: false,
          mode: 'snap',
          centered: true,
          slides: {
            perView: 2,
            spacing: 7,
          },
        },
        [window.BAO.Carousel.useInitialised()],
      )
    }
  }
}

if (!customElements.get('complete-products-carousel')) {
  customElements.define('complete-products-carousel', CompleteProductsCarousel)
}
